import React from "react";
import { Theme } from "interfaces/theme";
import * as S from "./styles";

interface IBanner {
  mode: Theme;
}
const Banner: React.FC<IBanner> = ({ mode }) => {
  return (
    <S.Container mode={mode}>
      <S.LegendLight>
        Camisa, Pucci. Vestido, Vitor Zerbinato. Colar, Swarovski. Brincos,
        Bottega Online.
      </S.LegendLight>
      <S.LegendDark>Camisa, Louis Vuitton</S.LegendDark>
      <S.Credits>
        <p>
          Fotos:
          <br />
          <span>Takeuchiss</span>
        </p>
        <p>
          Edição:
          <br />
          <span>Pedro Camargo</span>
        </p>
        <p>
          Beleza:
          <br />
          <span>Jake Falchi</span>
        </p>
        <p>
          Edição de moda:
          <br />
          <span>Lucas Boccalão</span>
        </p>
      </S.Credits>
      <S.Content>
        <S.Wrapper>
          <S.Title>Elas são o terror…</S.Title>
          <S.Text>
            Essas bruxas disfarçadas de patricinhas vão aprontar altas
            travessuras nesse Halloween de beauté inspirado nos anos 2000 que
            acaba de aterrissar na sua ELLE View. Aperte o botão para ver as
            duas versões dessa turminha do mal!
          </S.Text>
        </S.Wrapper>
      </S.Content>
    </S.Container>
  );
};

export default Banner;
